import { render, staticRenderFns } from "./ReceivershipForms.vue?vue&type=template&id=b400ef6c&scoped=true&"
import script from "./ReceivershipForms.vue?vue&type=script&lang=js&"
export * from "./ReceivershipForms.vue?vue&type=script&lang=js&"
import style0 from "./ReceivershipForms.vue?vue&type=style&index=0&id=b400ef6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b400ef6c",
  null
  
)

export default component.exports